import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { GbtimepointService, TimePointListEntryMeta } from '../gb-api';

@Injectable()
export class TimepointService {

  private readonly TIMEPOINT_ID = 'timepointId';

  private timePointSubject = new BehaviorSubject<TimepointCtx>(new TimepointCtx(new Date(), undefined, undefined));
  timePoint$ = this.timePointSubject.asObservable();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private gbTimepointService: GbtimepointService) {

    this.route.queryParamMap.subscribe(q => {
      if (q.get(this.TIMEPOINT_ID)) {
        const timepointId = q.get(this.TIMEPOINT_ID);
        this.timePointSubject.next(new TimepointCtx(this.timePointSubject.value.timepoint, timepointId, this.gbTimepointService.loadTimepointListEntryById(timepointId)));
      } else {
        this.timePointSubject.next(new TimepointCtx(this.timePointSubject.value.timepoint, undefined, undefined));
      }
    });
  }

  resetTimepoint() {
    this.timePointSubject.next(new TimepointCtx(new Date(), undefined, undefined));
  }

  private updateRoute() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: { timepointId: this.timePointSubject.value.timepointId },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
  }

  set timepointId(value: string) {
    this.timePointSubject.next(new TimepointCtx(this.timePointSubject.value.timepoint, value, this.gbTimepointService.loadTimepointListEntryById(value)));
    this.updateRoute();
  }

  get timepointCtx(): TimepointCtx {
    return this.timePointSubject.value;
  }

}

export class TimepointCtx {

  timepoint: Date;
  timepointId: string;
  timepointListEntry: TimePointListEntryMeta;

  private subscription: Subscription;

  constructor(timePoint: Date, timepointId: string, timepointRequest: Observable<TimePointListEntryMeta>) {
    this.timepoint = timePoint;
    this.timepointId = timepointId;
    if (timepointRequest) {
      this.subscription = timepointRequest.subscribe({
        next: (t) => this.timepointListEntry = t,
        error: () => this.timepointListEntry = undefined
      });
    } else {
      this.timepointListEntry = undefined;
    }
  }

  get timepointIso(): string {
    return this.timepoint ? this.timepoint.toISOString() : undefined;
  }

  get hasTimepointListEntry(): boolean {
    return !!this.timepointListEntry;
  }

}
